class FilterGrid extends HTMLElement {
  filterForm = null;
  clearButton = null;
  inputs = [];
  updateButton = null;
  startState = {};
  state = {};
  allowSubmit = true;

  constructor() {
    super();
    this.filterForm = this.querySelector('form');
    this.clearButton = this.querySelector('.filter-grid__clear');
    this.updateButton = this.querySelector('.filter-grid__update');
    this.inputs = this.querySelectorAll('input');

    this._clearForm = this.clearForm.bind(this);
    this._onInputChange = this.onInputChange.bind(this);
    this._onFormSubmitPrevent = this.onFormSubmitPrevent.bind(this);

    this.createState();
    this.onInputChange();
  }

  connectedCallback() {
    this.addEventListeners();
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    if (this.clearButton) {
      this.clearButton.addEventListener('click', this._clearForm);
    }
    this.inputs.forEach(input => {
      input.addEventListener('change', this._onInputChange);
      if (input.type === 'search' || input.type === 'text') {
        input.addEventListener('input', this._onInputChange);
      }
    });
    if (this.filterForm) {
      this.filterForm.addEventListener('submit', this._onFormSubmitPrevent);
    }
  }
  removeEventListeners() {
    if (this.clearButton) {
      this.clearButton.removeEventListener('click', this._clearForm);
    }
    this.inputs.forEach(input => {
      input.removeEventListener('change', this._onInputChange);
      if (input.type === 'search' || input.type === 'text') {
        input.removeEventListener('input', this._onInputChange);
      }
    });
    if (this.filterForm) {
      this.filterForm.removeEventListener('submit', this._onFormSubmitPrevent);
    }
  }

  getState() {
    let state = {};
    this.inputs.forEach(input => {
      let input_name = input.name.replace('[]', '');

      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.type === 'checkbox') {
          if (!state[input_name]) state[input_name] = [];
          if (input.checked) state[input_name].push(input.value);
        } else {
          if (input.checked) {
            state[input_name] = input.value;
          }
        }
      } else {
        state[input_name] = input.value;
      }
    });
    return state;
  }

  createState() {
    this.startState = this.getState();
    this.state = this.startState;
  }

  compareState(state1, state2) {
    return JSON.stringify(state1) === JSON.stringify(state2);
  }

  onInputChange() {
    let newState = this.getState();
    if (this.updateButton) {
      this.updateButton.disabled = this.compareState(this.startState, newState);
    }

    if (!this.compareState(this.state, newState) && this.filterForm) {
      this.dispatchEvent(
        new CustomEvent('change', {
          detail: {
            state: newState,
          },
        }),
      );
    }

    this.state = newState;
  }

  clearForm(e) {
    e.preventDefault();

    // Reset all inputs to empty values, covering different input types
    this.inputs.forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      } else if (input.type === 'range') {
        input.value = input.name.match(/max/) ? input.max : input.min;
      } else {
        input.value = '';
      }
    });

    // Dispatch a custom event to notify other components that the form has been reset
    if (this.filterForm) {
      this.filterForm.dispatchEvent(new Event('clear'));
    }

    this.onInputChange();
  }

  setAllowSubmit(value) {
    this.allowSubmit = value;

    if (this.updateButton) {
      if (this.allowSubmit) {
        this.updateButton.removeAttribute('hidden');
      } else {
        this.updateButton.setAttribute('hidden', true);
      }
    }
  }

  onFormSubmitPrevent(e) {
    if (!this.allowSubmit) {
      e.preventDefault();
    }
  }
}

window.customElements.define('filter-grid', FilterGrid);
